import { ApiClientReturnType, KeyLabelType } from '~/types';
import api from '../http-common';

const getOptionsData = (signal?: AbortSignal): ApiClientReturnType<PopupOptionsType> =>
  api.post('/settings/pop-ups/get-options-data', {}, { signal });

const createLoginPopup = (data) =>
  api.post('/settings/pop-ups/store', data)

const getLoginPopupsList = (signal?: AbortSignal): ApiClientReturnType<LoginPopupsType> =>
  api.post('/settings/pop-ups/index', {}, { signal })

const getLoginPopup = (id: string, signal?: AbortSignal) =>
  api.post(`/settings/pop-ups/${id}/edit`, {}, { signal })

const updateLoginPopup = (id, data) =>
  api.post(`/settings/pop-ups/${id}/update`, data)

const showLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/show`)

const deleteLoginPopup = (id) =>
  api.post(`/settings/pop-ups/${id}/delete`)

const getFileUrl = (id, data?) =>
  api.post(`/settings/pop-ups/${id}/get-file-url`, data)

/// Farmer login popups

const getFarmerLoginPopups = () =>
  api.post('/pop-ups/get-data')

const enableLoginPopups = () =>
  api.post('/pop-ups/enable-on-login')

const disableLoginPopups = () =>
  api.post('/pop-ups/disable-on-login')

const getFarmerLoginPopupUrl = (id: string) =>
  api.post(`/pop-ups/${id}/get-file-url`)

/// Change data requests

const getChangeDataRequestsIndexData = (data?): ApiClientReturnType<ChangeReqOptionsType> =>
  api.post('/change-data-requests/get-index-data', data)

const getChangeDataRequests = (data?): ApiClientReturnType<ChangeRequestsType> =>
  api.post('/change-data-requests/index', data)

const getChangeDataCounts = (data?): ApiClientReturnType<ChangeCoutType[]> =>
  api.post('/change-data-requests/count', data)

const getChangeDataRequestFields = (id): ApiClientReturnType<ChangeRequestReviewType[]> =>
  api.post(`/change-data-requests/${id}/get-fields`)

const resolveChangeDataRequest = (id, data?) =>
  api.post(`/change-data-requests/${id}/resolve`, data)

const acceptChangeDataRequestField = (id, fieldId) =>
  api.post(`/change-data-requests/${id}/fields/${fieldId}/accept`)

const rejectChangeDataRequestField = (id, fieldId) =>
  api.post(`/change-data-requests/${id}/fields/${fieldId}/reject`)

export const LoginPopupsService = {
  getOptionsData,
  createLoginPopup,
  getFileUrl,
  getLoginPopup,
  updateLoginPopup,
  showLoginPopup,
  deleteLoginPopup,
  getLoginPopupsList,
  getFarmerLoginPopups,
  getFarmerLoginPopupUrl,
  enableLoginPopups,
  disableLoginPopups,
  getChangeDataRequestsIndexData,
  getChangeDataRequests,
  getChangeDataRequestFields,
  resolveChangeDataRequest,
  acceptChangeDataRequestField,
  rejectChangeDataRequestField,
  getChangeDataCounts
}

export interface PopupOptionsType {
  types: Type[];
  farmerGroups: FarmerGroup[];
  roles: Role[];
  fields: Fields;
}

export interface Fields {
  manager: Manager[];
  user: Manager[];
}

export interface Manager {
  slug: string;
  label: string;
  category: Category;
  required: number;
  showAvailable: number;
  changeAvailable: number;
  requestNewAvailable: number;
}

export enum Category {
  FarmerData = 'farmer_data',
  ManagerData = 'manager_data',
  UserData = 'user_data',
}

export interface Role {
  id: number;
  slug: string;
  label: string;
}

export interface Type {
  key: number;
  label: string;
}

export interface FarmerGroup {
  id: string;
  name: string;
  amountPercent: string;
}

export interface LoginPopupsType {
  rows: Row[];
  total: number;
  filtered: number;
}

export interface Row {
  id: string;
  name: string;
  from: string;
  to: string;
  status: number;
  downloadEnabled: number;
  createdAt: Date;
  farmerGroups: string[];
  roles: number[];
}

export interface ChangeRequestsType {
  rows: Row[];
  total: number;
  filtered: number;
}

export interface ChangeRequestType {
  id: number;
  userId: string;
  popUpId: string;
  status: number;
  reviewedBy: null;
  reviewedAt: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  accepted: number;
  rejected: number;
  total: number;
}
export interface ChangeReqOptionsType {
  statuses: KeyLabelType[];
}

export interface Status {
  key: number;
  label: string;
}

export interface ChangeRequestReviewType {
  id: number;
  changeDataRequestId: number;
  slug: string;
  category: Category;
  farmerId: null | string;
  oldValue: any;
  newValue: string;
  action: string;
  status: number;
  reviewedBy: null;
  reviewedAt: string;
  companyName: null | string;
  evsNumber: null | string;
  reviewer: null;
  label: string;
  statusLabel: string;
  actionLabel: string;
  createdAt?: string;
}

export interface ChangeCoutType {
  status: number;
  count: number;
}
